import "@/helpers/firebase";
import { createApp } from 'vue';
import App from './App.vue';
import router from "./router";
import AOS from 'aos';
import 'aos/dist/aos.css';
import i18n from './i18n';
import store from "./state/store"; // eslint-disable-line

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

import BootstrapVueNext from 'bootstrap-vue-next';
import vClickOutside from "click-outside-vue3";
import VueApexCharts from "vue3-apexcharts";
import { vMaska } from "maska"

import VueFeather from 'vue-feather';

import '@/assets/scss/config/saas/app.scss';
import '@/assets/scss/mermaid.min.css';
import 'bootstrap/dist/js/bootstrap.bundle'

import Vueform from '@vueform/vueform'
import vueformConfig from './../vueform.config'
import { createGtm } from '@gtm-support/vue-gtm';
import { createHead, VueHeadMixin } from '@unhead/vue/client'

const STORAGE_KEY = 'mysticlog-lang'; // Define a key for localStorage
const savedLang = localStorage.getItem(STORAGE_KEY);
const defaultLang = 'en'; // Your default language

// Determine the initial language
let initialLang = defaultLang;
const availableLocales = i18n.global.availableLocales;
if (savedLang && availableLocales.includes(savedLang)) {
    // Use saved language if it exists and is valid
    initialLang = savedLang;
} else {
    // Optional: You could try detecting browser language as a fallback
    const browserLang = navigator.language.split('-')[0];
    if (availableLocales.includes(browserLang)) {
        initialLang = browserLang;
    }
    // If savedLang was invalid, clear it or reset it
    if (savedLang) {
        localStorage.removeItem(STORAGE_KEY);
    }
}

i18n.global.locale = initialLang;

AOS.init({
    easing: 'ease-out-back',
    duration: 1000
});

const app = createApp(App); // Create the app instance

app
    .use(store)
    .use(router)
    .use(VueApexCharts)
    .use(BootstrapVueNext)
    .component(VueFeather.type, VueFeather)
    .directive("maska", vMaska)
    .use(i18n)
    .use(VueSweetalert2)
    .use(Vueform, vueformConfig)
    .use(vClickOutside)
    .use(createHead())
    .use(createGtm({
        id: process.env.VUE_APP_GTM_ID,
        enabled: true, // Forcing true for easier debugging. Revert to process.env.NODE_ENV checks if needed.
        debug: false,   // Forcing true for easier debugging.
        loadScript: true,
        vueRouter: router,
        vueRouterAdditionalEventData: () => {
            let planType = 'guest';
            if (store.state.auth.firestoreUser && store.state.auth.firestoreUser.currentPlanType) {
                planType = store.state.auth.firestoreUser.currentPlanType;
            } else if (store.state.auth.currentUser && !store.state.auth.firestoreUser) {
                // User is logged in (auth object exists), but firestore details (plan) might still be loading.
                // 'free' can be a sensible default until firestoreUser populates.
                planType = 'free'; 
            }
            return {
                user_plan: planType,
            };
          },
    }));

app.mixin(VueHeadMixin)
app.mount('#app'); // Mount the app last